// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2q_Ye","loaderOuter":"PageOverlayLoader_loaderOuter__xtR8L"};